

import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Routes, Route } from "react-router-dom";
import { layoutTypes } from "./constants/layout";
// Import Routes all
import { authProtectedRoutes, publicRoutes, eCommerceProtectedRoutes } from "./routes";

// Import all middleware
import Authmiddleware from "./routes/route";

// layouts Format
import VerticalLayout from "./components/VerticalLayout/";
import HorizontalLayout from "./components/HorizontalLayout/";
import NonAuthLayout from "./components/NonAuthLayout";

// Import scss
import "./assets/scss/theme.scss";


// Import Firebase Configuration file
// import { initFirebaseBackend } from "./helpers/firebase_helper";

import fakeBackend from "./helpers/AuthType/fakeBackend";

// Activating fake backend
fakeBackend();

// const firebaseConfig = {
//   apiKey: process.env.REACT_APP_APIKEY,
//   authDomain: process.env.REACT_APP_AUTHDOMAIN,
//   databaseURL: process.env.REACT_APP_DATABASEURL,
//   projectId: process.env.REACT_APP_PROJECTID,
//   storageBucket: process.env.REACT_APP_STORAGEBUCKET,
//   messagingSenderId: process.env.REACT_APP_MESSAGINGSENDERID,
//   appId: process.env.REACT_APP_APPID,
//   measurementId: process.env.REACT_APP_MEASUREMENTID,
// };

// init firebase backend
// initFirebaseBackend(firebaseConfig);

const getLayout = (layoutType) => {
  let Layout = VerticalLayout;
  switch (layoutType) {
    case layoutTypes.VERTICAL:
      Layout = VerticalLayout;
      break;
    case layoutTypes.HORIZONTAL:
      Layout = HorizontalLayout;
      break;
    default:
      break;
  }
  return Layout;
};

import axios from "axios";
import GetAuthToken from "customhooks/TokenVerifivation/GetAuthToken";
import { API_GET_ROLE_PERMSSIONS_DATA } from "customhooks/All_Api/Apis";
import EcommerceAuthmiddleware from "routes/ecommerceRoutes";
import ProductsHome from "pages/MilkmorEcommerce/ProductsHome/productsHome";

const App = () => {
  const { layoutType } = useSelector((state) => ({
    layoutType: state.Layout.layoutType,
  }));

  const Layout = getLayout(layoutType);
  const config = GetAuthToken();

  const [permissions, setPermissions] = useState(null);

  // console.log("permissions in app.js", permissions);

  useEffect(() => {
    const fetchPermissions = async () => {
      try {
        try {
          const { data } = await axios.get(
            API_GET_ROLE_PERMSSIONS_DATA,
            config?.config
          );
          setPermissions(data.data);
        } catch (error) {
          console.log(error);
        }
      } catch (error) {
        console.error("Error fetching permissions:", error);
      }
    };

    fetchPermissions();
  }, []);

  return (
    <React.Fragment>
      <Routes>
        {publicRoutes && publicRoutes?.map((route, idx) => (
          <Route
            path={route?.path}
            element={<NonAuthLayout>{route?.component}</NonAuthLayout>}
            key={idx}
            exact={true}
          />
        ))}

        {authProtectedRoutes && authProtectedRoutes?.map((route, idx) => (
          <Route
            path={route.path}
            element={
              <Authmiddleware permissions={permissions && permissions}>
                <Layout>{route.component}</Layout>
              </Authmiddleware>
            }
            key={idx}
            exact={true}
          />
        ))}
        {eCommerceProtectedRoutes && eCommerceProtectedRoutes?.map((route, idx) => (
          <Route
            path={route?.path}
            element={
              <EcommerceAuthmiddleware >
                <NonAuthLayout>{route.component}</NonAuthLayout>
              </EcommerceAuthmiddleware>
            }
            key={idx}
            exact={true}
          />
        ))}

      </Routes>
    </React.Fragment>
  );
};

App.propTypes = {
  layout: PropTypes.any,
};

export default App;